module.exports = "<app-header></app-header>\n<div class=\"container-fluid main\">\n    <div class=\"row\">\n        <app-messages class=\"col-md-12\"></app-messages>\n    </div>\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main